import Vue from 'vue';
import Router from 'vue-router';

import { authorize, logout, allowedToDeveloperOrSpectator } from './helpers';
import { loadConfig } from '../config';

// site
import Home from 'views/site/Home.vue';
import Login from 'views/site/Login.vue';
import Register from 'views/site/Register.vue';
import ResetPasswordRequest from 'views/site/ResetPasswordRequest.vue';
import PasswordRules from 'views/site/PasswordRules.vue';
import ResetPassword from 'views/site/ResetPassword.vue';
import AppUserEmailActions from 'views/site/AppUserEmailActions.vue';
import EmailConfirmation from 'views/site/EmailConfirmation.vue';
import UserInvitation from 'views/site/UserInvitation.vue';
import UserMfaReset from 'views/site/UserMfaReset.vue';
import Settings from 'views/site/Settings/Index.vue';
import DeletionRequestConfirmation from 'views/site/Settings/DeletionRequestConfirmation.vue';
import NotFound from 'views/site/NotFound.vue';

// indexes
import ApplicationIndex from 'views/boards/ApplicationIndex.vue';
import BoardIndex from 'views/boards/BoardIndex.vue';

// boards
import HomeBoard from 'views/boards/home/HomeBoard.vue';
import OverviewBoard from 'views/boards/overview/OverviewBoard.vue';
import AudienceBoard from 'views/boards/audience/AudienceBoard.vue';
import TripBoard from 'views/boards/trip/TripBoard.vue';
import UserBoard from 'views/boards/user/UserBoard.vue';
import UsersBoard from 'views/boards/users/UsersBoard.vue';
import WebhookBoard from 'views/boards/webhooks/WebhookBoard.vue';
import ApiKeyBoard from 'views/boards/api_keys/ApiKeyBoard.vue';
import ActivitiesBoard from 'views/boards/activities/ActivitiesBoard.vue';

// plugin: crash reporting
import CrashReport from 'components/crash_report/CrashReport.vue'
import CrashReports from 'components/crash_report/CrashReports.vue'

// config
Vue.use(Router);

const routes = [
  // home
  { path: '/', name: 'home', redirect: { name: 'apps' } },

  // auth
  { path: '/login', name: 'login', component: Login },
  { path: '/logout', name: 'logout', beforeEnter: logout },
  { path: '/register', name: 'register', component: Register },
  {
    path: '/password-rules',
    name: 'reset-password-rules',
    component: PasswordRules,
  },
  {
    path: '/reset-password-request',
    name: 'reset-password-request',
    component: ResetPasswordRequest,
  },
  {
    path: '/app-user-email-actions',
    name: 'app-user-email-actions',
    component: AppUserEmailActions,
  },
  {
    path: '/reset-password/:reset_password_token',
    name: 'reset-password',
    component: ResetPassword,
  },
  {
    path: '/reset-password',
    name: 'business-reset-password',
    component: ResetPassword,
  },
  {
    path: '/email-confirmation/:code',
    name: 'email-confirmation',
    component: EmailConfirmation,
  },
  {
    path: '/user-invitations/:code',
    name: 'user-invitations',
    component: UserInvitation,
  },
  {
    path: '/user-mfa-resets/:code',
    name: 'user-mfa-resets',
    component: UserMfaReset,
  },

  // account
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    beforeEnter: authorize,
    children: [
      {
        path: '/deletion-request-confirmation',
        name: 'deletion-request-confirmation',
        component: DeletionRequestConfirmation,
      },
    ],
  },
  {
    path: '/apps',
    name: 'apps',
    component: ApplicationIndex,
    beforeEnter: authorize,
  },
  {
    path: '/apps/:appId',
    component: BoardIndex,
    beforeEnter: authorize,
    children: [
      {
        path: '/',
        name: 'app',
        redirect: { name: 'audience' },
      },
      {
        path: 'webhooks',
        name: 'webhooks',
        component: WebhookBoard,
      },
      {
        path: 'api_keys',
        name: 'api_keys',
        component: ApiKeyBoard,
      },
      {
        path: 'activities',
        name: 'activities',
        component: ActivitiesBoard,
        beforeEnter: allowedToDeveloperOrSpectator,
      },
      {
        path: 'boards/:boardId',
        name: 'overview',
        component: OverviewBoard,
      },
      {
        path: 'audience',
        name: 'audience',
        component: AudienceBoard,
      },
      {
        path: 'users',
        name: 'users',
        component: UsersBoard,
      },
      {
        path: 'audience/users/:userId',
        name: 'audience-user',
        component: UserBoard,
      },
      {
        path: 'audience/users/:userId/trips/:tripStart',
        name: 'audience-trip',
        component: TripBoard,
      },
    ],
  },

  // crash reportings
  {
    path: '/crash-reporting/:account_id/apps/:app_id',
    name: 'crash-reporting-listing',
    component: CrashReports,
    beforeEnter: authorize,
  },
  {
    name: 'crash-report',
    path: '/crash-reporting/:account_id/apps/:app_id/report/:report_id',
    component: CrashReport,
    beforeEnter: authorize,
  },

  // 404
  { path: '*', component: NotFound },
];

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  loadConfig().then(next);
});

export default router;
